import { render, staticRenderFns } from "./OrderPriceTable.vue?vue&type=template&id=6f95189b&scoped=true"
import script from "./OrderPriceTable.vue?vue&type=script&lang=js"
export * from "./OrderPriceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f95189b",
  null
  
)

export default component.exports